import { CloseOutlined } from '@ant-design/icons';
import { Button, Form } from 'antd';
import { useCallback, useContext } from 'react';

import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';

import { TimeSlotsEditor } from './TimeSlotsEditor';
import { DEFAULT_SLOT } from './utils';

export const OpeningHoursWeekly = () => {
  const { isViewMode } = useContext(ViewEditModeContext);
  const form = Form.useFormInstance();
  const isAllDay = Form.useWatch(['openingHours', 'isAllDay'], form);

  const handleAllDay = useCallback(() => {
    const current = form.getFieldValue(['openingHours', 'isAllDay']);

    form.setFieldValue(['openingHours', 'isAllDay'], !current);
  }, [form]);

  return (
    <div>
      {isAllDay ? (
        <Button
          onClick={handleAllDay}
          icon={<CloseOutlined />}
          disabled={isViewMode}
        >
          24/24
        </Button>
      ) : (
        <TimeSlotsEditor
          timeSlotName={['openingHours', 'slots']}
          onAllDayClick={handleAllDay}
          initialValues={[DEFAULT_SLOT]}
        />
      )}
    </div>
  );
};
